module.exports = new __parcel__URL__("industrial-sm.5d885aaf.jpg").toString();